import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Message } from "../models/message";

@Injectable({
	providedIn: 'root',
})
export class MessageService {

	private validationSubject = new Subject<string[]>();
	private errorSubject = new Subject<Message>();
	private createdSubject = new Subject<Message>();

	public notifyValidation(title: string, validationErrors: any) {

		let errorMessages: string[] = [];
		for (let [key, value] of Object.entries(validationErrors.errors)) {

			errorMessages.push(value.toString());
		}

		this.validationSubject.next(errorMessages);
	}

	public validationMessagesChange(): Observable<string[]> {

		return this.validationSubject.asObservable();
	}

	public clearValidationMessages() {

		this.validationSubject.next(null);
	}

	public notifyError(title: string, body: string) {

		let message = new Message(title, body);

		this.errorSubject.next(message);
	}

	public getErrorMessages(): Observable<Message> {

		return this.errorSubject.asObservable();
	}

	public notifyCreated(title: string, body: string) {

		let message = new Message(title, body);

		this.createdSubject.next(message);
	}

	public getCreatedMessages(): Observable<Message> {

		return this.createdSubject.asObservable();
	}
}